import { logger } from '@luna/logger';

type GetToken = () => string;

let getTokenImplementation: GetToken;

export function initGetToken(newGetToken: GetToken): void {
    getTokenImplementation = newGetToken;
}

export const getToken: GetToken = () => {
    if (!getTokenImplementation) {
        logger.error('getToken implementation not found! Please provide one for initGetToken');
        return '';
    }

    return getTokenImplementation();
};
